import { T } from 'ia-react-core/~/interfaces/t';

export type TranslationMessages = any;

export interface TranslationQueueItem {
  language: string;
  namespace: string;
  messages: TranslationMessages;
}

export interface TranslationImpl {
  addTranslation: (
    language: string,
    namespace: string,
    messages: any
  ) => any;
  changeLanguage: (lng?: string, callback?: () => void) => any;
  t: T;
  getLanguage: () => string;
  onLanguageChange: (callback: ((language: string) => void)) => void;
  offLanguageChange: (callback: ((language: string) => void)) => void;
}

class Translation {
  static #implementation: TranslationImpl = null;
  static #queue: TranslationQueueItem[] = [];

  static setImplementation(implementation: TranslationImpl) {
    this.#implementation = implementation;

    this.#queue.forEach(({ language, namespace, messages }) => {
      this.addTranslation(language, namespace, messages);
    });
    this.#queue = [];
  }

  static addTranslation(language: string, namespace: string, messages: TranslationMessages) {
    if (this.#implementation) {
      this.#implementation.addTranslation(language, namespace, messages);
    } else {
      this.#queue.push({ language, namespace, messages });
    }
  }

  static t(key: string, options?: Record<string, unknown>): string {
    return this.#implementation.t(key, options);
  }

  static get language() {
    return this.#implementation.getLanguage();
  }

  static changeLanguage(newLanguage: string) {
    return this.#implementation.changeLanguage(newLanguage);
  }

  static getInitialTranslations() {
    return this.#queue;
  }

  static onLanguageChange(callback: (language: string) => void) {
    this.#implementation.onLanguageChange(callback);
    return () => this.offLanguageChange(callback);
  }

  static offLanguageChange(callback: (language: string) => void) {
    this.#implementation.offLanguageChange(callback);
  }
}

export default Translation;
